/* eslint-disable quotes */
import { AlertIcon } from 'assets/icons/AlertIcon'
import { CheckIcon } from 'assets/icons/CheckIcon'
import { CycleIcon } from 'assets/icons/CycleIcon'
import { employeesIcon } from 'assets/icons/EmployeesIcon'
import { FileIcon } from 'assets/icons/FileIcon'
import { financesIcon } from 'assets/icons/financesIcon'
import { IdleBellIcon } from 'assets/icons/IdleBellIcon'
import { inventoryIcon } from 'assets/icons/InventoryIcon'
import { LightningSlashIcon } from 'assets/icons/LightningSlashIcon'
import { machineryIcon } from 'assets/icons/MachineryIcon'
import { PauseIcon } from 'assets/icons/PauseIcon'
import { PendingIcon } from 'assets/icons/PendingIcon'
import { PlayIcon } from 'assets/icons/PlayIcon'
import { SettingsIcon } from 'assets/icons/SettingsIcons'
import { StopIcon } from 'assets/icons/StopIcon'
import { WarningTriangleIcon } from 'assets/icons/WarningTriangleIcon'
import { WorkflowIcon } from 'assets/icons/WorkflowIcon'
import { tokens } from 'styling/tokens'

export const dashboardAlertCards = [
  { name: 'Problem Reports', prop: 'reports' },
  { name: 'Restricted Area Breaches', prop: 'restrictedArea' },
  { name: 'Delayed Tasks', prop: 'delayedTasks' },
  { name: 'Unusual Activity Detection', prop: 'unusualActivity' },
  { name: 'Resource Overuse Alert', prop: 'resourceOveruse' },
  { name: 'Unusual Fuel Usage', prop: 'unusualFuel' },
]

export const inventoryOptins = [{ label: 'All Items', value: 1 }]

export const areaData = [
  {
    name: '8AM',
    actualCost: 2400,
    estimatedCost: 2400,
  },
  {
    name: '10AM',
    actualCost: 1398,
    estimatedCost: 2210,
  },
  {
    name: '12AM',
    actualCost: 9800,
    estimatedCost: 2290,
  },
  {
    name: '2PM',
    actualCost: 3908,
    estimatedCost: 2000,
  },
  {
    name: '4PM',
    actualCost: 4800,
    estimatedCost: 2181,
  },
  {
    name: '6PM',
    actualCost: 3800,
    estimatedCost: 2500,
  },
  {
    name: '8PM',
    actualCost: 4300,
    estimatedCost: 2100,
  },
]

export const machineryData = [
  {
    name: 'Free',
    value: 5,
  },
  {
    name: 'Busy',
    value: 10,
  },
  {
    name: 'In Maintenence',
    value: 15,
  },
  {
    name: 'Paused',
    value: 10,
  },
  {
    name: 'Broken',
    value: 20,
  },
]

export const machineryStatusesData = [
  {
    id: 1,
    name: 'Free',
    color: tokens.accent.base,
    icon: IdleBellIcon,
    iconColor: tokens.accent.base,
  },
  {
    id: 2,
    name: 'Busy',
    color: tokens.status.success.fg,
    icon: PendingIcon,
    iconColor: tokens.status.success.fg,
  },
  {
    id: 3,
    name: 'Broken',
    color: tokens.status.danger.fg,
    icon: WarningTriangleIcon,
    iconColor: tokens.status.danger.fg,
  },
  {
    id: 4,
    name: 'In Maintenance',
    color: tokens.status.info.fg,
    icon: SettingsIcon,
    iconColor: tokens.status.info.fg,
  },
  {
    id: 5,
    name: 'Paused',
    color: tokens.status.warning.fg,
    icon: PauseIcon,
    iconColor: tokens.status.warning.fg,
  },
]
// NotStarted = 0, InProgress = 1, Paused = 2, Completed = 3, Reported = 4, Idle = 5, AbleToContinue = 6, Stopped = 7

export const taskStatusesData = [
  {
    id: 0,
    name: 'Not Started',
    icon: LightningSlashIcon,
  },
  {
    id: 1,
    name: 'In Progress',
    icon: PendingIcon,
  },
  {
    id: 2,
    name: 'Paused',
    icon: PauseIcon,
  },
  {
    id: 3,
    name: 'Completed',
    icon: CheckIcon,
  },
  {
    id: 4,
    name: 'Reported',
    icon: WarningTriangleIcon,
  },
  {
    id: 5,
    name: 'Idle',
    icon: IdleBellIcon,
  },
  {
    id: 6,
    name: 'Able To Continue',
    icon: PlayIcon,
  },
  {
    id: 7,
    name: 'Stopped',
    icon: StopIcon,
  },
]

export const widgetsList = [
  {
    width: 1,
    type: 'tasks',
    icon: FileIcon,
    title: 'Tasks',
    desc: 'All task statuses',
  },
  {
    width: 1,
    type: 'cycles',
    icon: CycleIcon,
    title: 'Cycles',
    desc: 'All cycle statuses',
  },
  {
    width: 1,
    type: 'workers',
    icon: employeesIcon,
    title: 'Employees',
    desc: 'Workers by shifts',
  },
  {
    width: 1,
    type: 'inventory',
    icon: inventoryIcon,
    title: 'Inventory',
    desc: "Selected items' count",
  },
  {
    width: 1,
    type: 'machinery',
    icon: machineryIcon,
    title: 'Machinery',
    desc: 'Machinery statuses',
  },
  {
    width: 2,
    type: 'alerts',
    icon: AlertIcon,
    title: 'Alerts',
    desc: 'Current alerts',
  },
  ,
  {
    width: 1,
    type: 'finances',
    icon: financesIcon,
    title: 'Finances',
    desc: 'Finances for present day',
  },
  {
    width: 1,
    type: 'workflows',
    icon: WorkflowIcon,
    title: 'Workflows',
    desc: 'All workflows statuses',
  },
  {
    width: 1,
    type: 'attendance',
    icon: FileIcon,
    title: 'Attendance',
    desc: 'Attendance overview',
  },
  {
    width: 1,
    type: 'shifts',
    icon: FileIcon,
    title: 'Shifts',
    desc: 'Shift coverage',
  },
  {
    width: 1,
    type: 'accommodation',
    icon: FileIcon,
    title: 'Accommodation',
    desc: 'Accommodation status',
  },
  {
    width: 1,
    type: 'notifications',
    icon: FileIcon,
    title: 'Notifications',
    desc: 'Latest HR notifications',
  },
  {
    width: 2,
    type: 'suggestions',
    icon: FileIcon,
    title: 'AI Suggestions',
    desc: 'Latest AI suggestions',
  },
  {
    width: 2,
    type: 'hr-alerts',
    icon: FileIcon,
    title: 'Alerts & Requests',
    desc: 'HR alerts and requests',
  },
  {
    width: 1,
    type: 'food',
    icon: FileIcon,
    title: 'Food Operations',
    desc: 'Food operations status',
  },
  {
    width: 1,
    type: 'transportation',
    icon: FileIcon,
    title: 'Transportation',
    desc: 'Transportation status',
  },
  {
    width: 1,
    type: 'department',
    icon: FileIcon,
    title: 'By Department',
    desc: 'Department overview',
  },
]

export const initialAreas = {
  '1': 'alerts',
  '2': 'alerts',
  '3': 'tasks',
  '4': 'cycles',
  '5': 'finances',
  '6': 'workers',
  '7': 'machinery',
  '8': 'inventory',
}

export const initialPresentWidgets = [
  'alerts',
  'tasks',
  'cycles',
  'finances',
  'workers',
  'machinery',
  'inventory',
]
